
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gynecology",
      function () {
        return require("private-next-pages/gynecology.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gynecology"])
      });
    }
  